
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface GamesPerDaySectionProps {
  form: UseFormReturn<any>;
  value: number;
  onChange: (value: number) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GamesPerDaySection: React.FC<GamesPerDaySectionProps> = ({ 
  form, 
  value, 
  onChange, 
  handleInputChange 
}) => {
  const { t } = useTranslationUtils();

  return (
    <FormField
      control={form.control}
      name="games_allowed_per_day"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('admin.gamesPerDay', 'Games Allowed Per Day')}</FormLabel>
          <FormControl>
            <Input
              id="games_allowed_per_day"
              name="games_allowed_per_day"
              type="number"
              min="0"
              value={value}
              onChange={(e) => {
                handleInputChange(e);
                const numValue = parseInt(e.target.value);
                if (!isNaN(numValue) && numValue >= 0) {
                  field.onChange(numValue);
                  onChange(numValue);
                }
              }}
              placeholder="3"
            />
          </FormControl>
          <p className="text-xs text-muted-foreground mt-1">
            {t('admin.gamesPerDayDesc', 'Number of mini-games a user can play per day. Games reset at midnight.')}
          </p>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default GamesPerDaySection;
